

































































import {Component, Vue} from 'vue-property-decorator';
  import ReportContainer from '../../components/report-container/report-container.vue';
  import FilterContainer from '../../components/filter-container/filter-container.vue';
  import {i18nMixin} from '@/modules/neodash/mixins';
  import {NameValue, NameValueGeneric, NameValues, NameValuesGeneric, OptionalNameValue} from '@/modules/neodash/model/types/interfaces/NameValue';
  import {MitsubishStoresLocation} from '@/modules/neodash/model/types/interfaces/MitsubishStoresLocation';
  import {IKeyValue, IKeyValues} from '@/interfaces/key-value-interface';
  import {FilterService} from '@/modules/neodash/services/filterService';
  import {Period, PeriodFormValue} from '@/modules/neodash/model/types/interfaces/Period';
  import {getUrlReportViewer} from '@/modules/neodash/model/constants/reportViewer';
  import {ReportsReportViewerEnum} from '@/modules/neodash/model/types/enums/reportsReportViewerEnum';
  import FilterFormatters from '@/modules/neodash/model/utils/filterFormatters';
  import {listAllSaleTypes} from '@/modules/neodash/model/constants/saleType';
  import ReportViewerContainer from '@/modules/neodash/components/report-viewer-container/report-viewer-container.vue';
  import ReportPlaceHolder from '@/modules/neodash/components/report-placeholder/report.placeholder.vue';
  import ReportAppBar from '@/modules/neodash/components/report-app-bar/report-app-bar.vue';
  import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
  import FormPeriod from '@/modules/neodash/components/filter-form/period-form/period-form.vue';
  import FilterMultiSelect from '@/modules/neodash/components/filter-form/filter-multi-select/filterMultiSelect.vue';
  import {GET_PERIOD} from '@/modules/neodash/store/modules/reports/types';
  import {Getter} from 'vuex-class';
  import {ReportEnum} from '@/modules/neodash/model/types/enums/reportEnum';
  import {CONFIG} from '@/config';
  import PageLoader from '@/components/page-loader/page-loader.vue';
  import {ServiceHelper} from '@/utils/service.helper';
  import {traceLogAccess} from '@/services';
  import {ContextEnum} from '@/enums/context.enum';
  import {SaleTypeEnum} from '@/modules/neodash/model/types/enums/saleTypeEnum';

  enum printingType {
    national = 1,
    regions = 2,
    areas = 3,
  }

  enum localeType {
    Operational = 'Operacional',
    OperationalMixed = 'Operacional Mista',
    Acting = 'Atuação',
  }

  interface labelFilter extends IKeyValue {
    type: printingType;
  }

  type StoresFilter = (obj: MitsubishStoresLocation) => boolean;

  enum salesType {
    Retail = 'Varejo',
    RetailExceptBigFleet = 'Varejo + VD (Exceto Big Fleet)',
    Total = 'Total'
  }

  @Component({
    name: 'SegmentPerformance',
    components: {
      PageLoader,
      ReportPlaceHolder,
      ReportViewerContainer,
      ReportAppBar,
      FilterContainer,
      ReportContainer,
      FilterDropDown,
      FilterMultiSelect,
      FormPeriod
    }
  })
  export default class SegmentPerformance extends Vue {
    public readonly translate = i18nMixin.methods.i18n;
    public readonly printingType = printingType;

    public readonly salesTypes: NameValues = [
      {name: salesType.Retail.toString(), value: SaleTypeEnum.RetailSales },
      {name: salesType.RetailExceptBigFleet.toString(), value: SaleTypeEnum.DirectSales },
      {name: salesType.Total.toString(), value: SaleTypeEnum.AllOfIt },
    ];

    public readonly keyLabelLocaleType: string = 'Common.LocaleType';
    public readonly keyLabelNational: string = 'Filters.LocationType.National';
    public readonly keyLabelRegional: string = 'Filters.LocationType.Regional';
    public readonly keyLabelActingArea: string = 'Common.Areas';
    public readonly keyLabelSaleType: string = 'Common.SaleType';
    public readonly keyLabelPrintType: string = 'Common.PrintType';
    public readonly keyLocaleTypeOperational = 'Filters.LocationType.OperationalArea';
    public readonly keyLocaleTypeOperationalMixed = 'Filters.LocationType.OperationalAreaMixed';
    public readonly keyLocaleTypeActing = 'Filters.LocationType.ActingArea';

    public readonly types: NameValues = [
      {name: this.translate(this.keyLabelNational), value: printingType.national},
      {name: this.translate(this.keyLabelRegional), value: printingType.regions},
      {name: this.translate(this.keyLabelActingArea), value: printingType.areas},
    ];

    public readonly localeType: NameValuesGeneric<string> = [
      {name: this.translate(this.keyLocaleTypeOperationalMixed), value: localeType.OperationalMixed.toString() },
      {name: this.translate(this.keyLocaleTypeActing), value: localeType.Acting.toString() },
    ];

    public chosenPrintType: NameValue = this.types[0];

    @Getter(GET_PERIOD)
    public getPeriod: (key: ReportEnum) => Period;

    public mitsubishStoresLocation: MitsubishStoresLocation[] = [];

    public chosenLocaleType: NameValueGeneric<string> = this.localeType[0];
    public chosenRegional: NameValues = [];
    public chosenActingArea: NameValues = [];
    public chosenPeriod: PeriodFormValue = null;
    public chosenSaleType: NameValue = this.salesTypes[0];

    public url: string = '';
    public labelFilters: IKeyValues = [];

    public get formValid(): boolean {
      const {chosenPrintType, chosenLocaleType, chosenSaleType} = this;
      if (!chosenPrintType || !chosenLocaleType || !chosenSaleType)
        return false;

      return !!chosenPrintType.value || !!chosenLocaleType.value && !!chosenSaleType.value;
    }

    public get limits(): Period {
      return this.getPeriod(ReportEnum.SegmentPerformanceDetailed)
    }

    public get allRegional(): NameValues {
      return this.mitsubishStoresLocation.distinctBy(x => x.idRegional).map(x => ({
        name: x.nameRegional,
        value: x.idRegional,
      }));
    }

    public get actingAreas(): NameValues {
      const filter: StoresFilter = x =>
        (this.chosenRegional.some(z => !!z && z.value === x.idRegional) || !this.chosenRegional.length)
          && x.localeType === this.chosenLocaleType.value;

      return this.mitsubishStoresLocation
        .filter(filter)
        .distinctBy(x => x.idArea)
        .map(x => ({
          name: x.nameArea,
          value: x.idArea
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    public created(): void {
      FilterService.getLocaleTypesMitsubishSegmentArea()
        .then(x => this.mitsubishStoresLocation = x)
    .then(_ => this.mitsubishStoresLocation = this.mitsubishStoresLocation.sort((a, b) => a.nameRegional.localeCompare(b.nameRegional)));
    }

    public showReport(): void {
      const {chosenPrintType, chosenPeriod, chosenLocaleType} = this;

      if (!chosenPrintType || !chosenPeriod || !chosenLocaleType)
        return;

      const params = {
        tipo: chosenPrintType.value,
        typeArea: chosenLocaleType.value,
        regional: this.chosenRegional,
        idLocale: this.chosenActingArea,
        tipoVenda: this.chosenSaleType.value,
        ...chosenPeriod.value
      };

      const reportType = this.chosenPrintType.value === printingType.areas
        ? ReportsReportViewerEnum.PerformanceSegmentContractualArea
        : ReportsReportViewerEnum.PerformanceSegmentRegionalsNational;

      traceLogAccess.logAction(ContextEnum.Report, `Análise da Área e Segmentação ${reportType} - Filtro`, JSON.stringify(params));
      this.url = getUrlReportViewer(reportType, params);
      this.updateFilters();
    }

    public shouldShow(type: printingType): boolean {
      return !!this.chosenPrintType && this.chosenPrintType.value >= type;
    }

    public downloadZipPages() {
      const {chosenPeriod, chosenSaleType, chosenLocaleType, chosenPrintType} = this;

      if (!chosenPeriod || !chosenSaleType || !chosenLocaleType || !chosenPrintType)
        return;

      let reportName = `PerfSeg_${chosenPrintType.value}`;
      if (this.chosenRegional.length)
        reportName += this.chosenRegional.length > 1 ? 'Regionais' : `_${this.chosenRegional[0].name}`;

      if (this.chosenActingArea.length)
        reportName += this.chosenActingArea.length > 1 ? 'Area de Atuacao' : `${this.chosenActingArea[0].name}`;

      const params = {
        idTargetType: chosenPrintType.value,
        idRegions: Array.from(this.chosenRegional, ({value}) => value),
        idActingArea: Array.from(this.chosenActingArea, ({value}) => value),
        saleType: chosenSaleType.value,
        initialYear: chosenPeriod.value.dtYearInit,
        initialMonth: chosenPeriod.value.dtMonthInit,
        finalYear: chosenPeriod.value.dtYearFinal,
        finalMonth: chosenPeriod.value.dtMonthFinal,
        PrefixReportName: reportName,
        LocaleTypeName: this.chosenLocaleType.value,
      };

      traceLogAccess.logAction(ContextEnum.Report, `Análise da Área e Segmentação ${reportName} - Download`, JSON.stringify(params));
      ServiceHelper.generateFile(`${CONFIG.URL.NEODASH_API}/api/neodash/getPdf/performanceSegment`, `${reportName}.zip`, {
        method: 'post',
        parameters: params
      });
    }

    private updateFilters(): void {
      const {translate, chosenActingArea, chosenRegional, chosenLocaleType, chosenPrintType, chosenSaleType, chosenPeriod, shouldShow} = this;

      if (!chosenLocaleType || !chosenPeriod || !chosenSaleType || !chosenPrintType)
        return;

      const getText = FilterFormatters.formatLabelMultiSelect;

      const labels: (labelFilter | IKeyValue)[] = [
        {text: this.keyLabelLocaleType, value: chosenLocaleType.name},
        {text: this.keyLabelRegional, value: getText(chosenRegional), type: printingType.regions},
        {text: this.keyLabelActingArea, value: getText(chosenActingArea), type: printingType.areas},
        {text: this.keyLabelSaleType, value: chosenSaleType.name},
        {text: 'Common.Period', value: chosenPeriod.label}
      ];

      this.labelFilters = labels
        .filter(x => {
          const label = x as labelFilter;
          return !label.type || shouldShow(label.type);
        })
        .map(({text, value}) => ({
          text: translate(text),
          value
        }));
    }

    public changePrintType() {
      this.chosenRegional = [];
      this.chosenActingArea = [];
    }

    public changeLocaleType() {
      this.chosenRegional = [];
      this.chosenActingArea = [];
    }
  }
